import { ExteriorQuestionType } from '../protos/backendproto/QuestionService_pb';
import { SaveExteriorQuestionsRequest } from '../protos/adminbackendproto/AdminQuestionService_pb';
import QuestionsWorkspace, { GroupAdapter } from './QuestionsWorkspace';

const exteriorAdapter: GroupAdapter<ExteriorQuestionType> = {
    title: "Exterior questions",
    noun: "area",
    groups: (response) => response.getExteriorQuestionsList(),
    name: (area) => area.getName(),
    setName: (area, name) => { area.setName(name) },
    create: () => new ExteriorQuestionType(),
    save: (client, areas) => client.saveExteriorQuestions(
        new SaveExteriorQuestionsRequest().setQuestionsPerAreaList(areas), {}),
};

export default function ExteriorQuestionsPage() {
    return <QuestionsWorkspace adapter={exteriorAdapter} />
}
